import React from "react";
import "./brakeRepair.css";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
export default function BrakeRepair() {
  return (
    <>
<Helmet>
  <title>
    Brake Repair & Brake Pad Replacement in Palwal | AutoCare
  </title>

  <meta
    name="description"
    content="Looking for reliable brake repair in Palwal? AutoCare provides professional brake pad replacement, disc repair, brake fluid service and complete braking system inspection."
  />

  <link
    rel="canonical"
    href="https://car-repair-mechanic-palwal.netlify.app/services/brake-repair"
  />
</Helmet>

    <section className="servicePage">
      <div className="serviceContent">

        {/* TEXT CONTENT */}
        <div className="textContent">
          <h1>Best Brake Repair Service in Palwal</h1>

          <p>
            Ensure your safety on the road with <strong>professional brake repair</strong> at
            <span className="highlight"> AutoCare</span>. We are a trusted
            <strong> car repair shop in Palwal</strong>, offering high-quality
            <span className="highlight"> brake services</span> for all types of vehicles.
          </p>

          <h2>What is Brake Repair?</h2>
          <p>
            Brake repair includes inspection, diagnosis, and replacement of worn-out components like brake pads, discs, calipers, and brake fluid.
            Our technicians ensure your car’s braking system performs safely and efficiently.
          </p>

          <h2>Brake Problems We Fix</h2>
          <ul>
            <li>Brake noise & squealing</li>
            <li>Soft or spongy brake pedal</li>
            <li>Brake fluid leaks & replacement</li>
            <li>Worn-out brake pads or discs</li>
            <li>ABS warning light issues</li>
            <li>Uneven braking & vibration</li>
          </ul>

          <h2>Why Choose AutoCare for Brake Repair?</h2>
          <ul>
            <li>Trusted <span className="highlight">brake repair service in Palwal</span></li>
            <li>Certified mechanics & advanced tools</li>
            <li>Genuine spare parts & brake components</li>
            <li>Fast, reliable, and safe service</li>
            <li>One-stop <span className="highlight">Auto Care in Palwal</span> for all car repairs</li>
          </ul>

          <h2>Brake Repair Near You</h2>
          <p>
            Searching for the <span className="highlight">best brake repair near me</span>?
            Choose <strong>AutoCare</strong> for dependable, affordable, and professional brake maintenance.
          </p>

          <button className="primaryBtn">
            <Link to="/contact">
            Book Brake Repair Service
            </Link>
          </button>
        </div>

        {/* IMAGE CONTENT */}
        <div className="imageContent">
          <img
            src="/carServiceImages/brake repair.webp"
            alt="Best Brake Repair Service in Palwal | AutoCare"
          />
        </div>

      </div>
    </section>
    </>
  );
}
